export default "__VITE_ASSET__5828136a__$_?nuxt_component=async__"